import { render, staticRenderFns } from "./SnippetsTab.vue?vue&type=template&id=0dad4e0a&"
import script from "./SnippetsTab.vue?vue&type=script&lang=js&"
export * from "./SnippetsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports